import { render } from "./Message.vue?vue&type=template&id=67519cfe&scoped=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"

import "./Message.vue?vue&type=style&index=0&id=67519cfe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67519cfe"

export default script